const castArray = a => {
  return Array.isArray(a) ? a : [a];
};
export { castArray };
